import { render } from "./VabeneAddProduct.vue?vue&type=template&id=5aa6108f&ts=true"
import script from "./VabeneAddProduct.vue?vue&type=script&lang=ts"
export * from "./VabeneAddProduct.vue?vue&type=script&lang=ts"

import "./VabeneAddProduct.vue?vue&type=style&index=0&id=5aa6108f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__